<template>
<div>
    <v-header></v-header>
    <v-headers></v-headers>
    <div class="feedback_container">
        <div class="wrap">
            <i class="icon-fanhui iconfont back" @click="backService"></i>

            <!-- service -->
            <div class="box service" v-show="showBoxIndex == 0">
                <p class="title">雀魂のお問い合わせについて</p>
                <div class="formWrap">
                    <ul>
                        <li class="mark">早期解決のため、事前に画面右上にある「FAQ」をご覧ください。</li>
                        <li>お問い合わせ状況等により、ご案内までにお時間を頂戴する場合もございます。</li>
                        <li>ご案内の際は、お問い合わせいただいたメールアドレスにのみご案内をしております。</li>
                        <li>必ずアカウントをご利用いただいているご本人様からのお問い合わせをお願いいたします。</li>
                        <li>メールアドレスに二つ以上の連続したピリオド「..」や「+」等の記号を使用されている場合、正常に受信や送信を行えない場合がございますので、別のメールアドレスからお問い合わせください。</li>
                        <li>初期設定で迷惑メールフィルタの設定がされていて、メールが受信できない場合がございますので、お問い合わせ前にご確認ください。</li>
                        <li>ドメイン指定受信を設定している場合、「mahjongsoul.com」のドメインからのメールの受信を許可に設定してください。</li>
                        <li>お電話でのサポートは行っておりません。こちらのフォームからのお問い合わせをお願いいたします。</li>
                        <li>上記に同意していただける場合、下記「お問い合わせフォームへ」からお問い合わせください。</li>
                    </ul>
                    <div class="selbox">
                        <label>カテゴリー</label>
                        <el-select v-model="serviceType" placeholder="選んでください">
                            <el-option
                                v-for="item in serviceList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                        <div class="btnbox">
                            <el-button size="medium" type="info" plain @click="selService">お問い合わせフォームへ</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <component :is="currentView"></component>
        </div>
    </div>
    <v-footer></v-footer>
</div>
    
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/dmmheader.vue";
import Headers from "@/components/dmmnavi_header.vue";
import kejin from "@/components/feedback/ser_kejin.vue";
import account from "@/components/feedback/ser_account.vue";
import bug from "@/components/feedback/ser_bug.vue";
import suggestion from "@/components/feedback/ser_suggestion.vue";
import contribute from "@/components/feedback/ser_contribute.vue";
import conference from "@/components/feedback/ser_conference.vue";
export default {
    name: "",

    components: {
        kejin,
        account,
        bug,
        suggestion,
        contribute,
        conference,
        "v-header": Header,
        "v-headers": Headers,
        "v-footer": Footer,
    },
    data() {
        return {
            serviceType: "",
            serviceList: [
                {
                    value: "1",
                    label: "アイテム購入時に問題が発生した"
                },
                {
                    value: "2",
                    label: "アカウントについて"
                },
                {
                    value: "3",
                    label: "不具合について"
                },
                {
                    value: "4",
                    label: "ご意見・ご要望"
                },
                {
                    value: "5",
                    label: "じゃんたま見聞録の投稿"
                },
                {
                    value: "6",
                    label: "公式大会への参加"
                }
            ],
            showBoxIndex: 0,
            boxArr: ["kejin", "account", 'bug', 'suggestion', 'contribute','conference']
        };
    },
    created() {
        if (!this.$utils.isPC()) {
            this.$store.commit("SET_LOGO_SHOW", false);
        }
    },
    mounted() {
        document.dispatchEvent(new Event('custom-render-trigger'))
    },
    methods: {
        backService() {
            this.showBoxIndex = 0;
        },
        selService() {
            if (this.serviceType != 0) {
                this.showBoxIndex = this.serviceType;
            }
        }
    },
    computed: {
        currentView() {
            return this.boxArr[this.showBoxIndex - 1];
        }
    }
};
</script>

<style lang="scss" scoped>
    .feedback_container {
        width: 100%;
        height: auto;
        background: url("../assets/images/special/bg.jpg") center center/ cover;
        overflow: hidden;
        position: relative;

        @media screen and (max-width: 600px) {
            // margin-top: MpxTorem(56px);
            background: url("../assets/images/special/special_bg.jpg") center center/ cover;
        }

        .wrap {
            width: 60%;
            height: auto;
            border: 1px solid #ac7f00;
            background: rgba(0, 0, 0, 0.7);
            margin: pxTorem(80px) auto;
            position: relative;

            @media screen and (max-width: 600px) {
                width: 90%;
                margin: MpxTorem(30px) auto;
            }

            .back {
                font-size: pxTorem(24px);
                cursor: pointer;
                color: #fff;
                position: absolute;
                top: pxTorem(10px);
                left: pxTorem(10px);
            }

            .box {
                width: 100%;
                box-sizing: border-box;
                color: #fff;

                & ::v-deep .el-button {
                    background: transparent;
                }

                .title {
                    width: 100%;
                    background: #000;
                    box-sizing: border-box;
                    padding: pxTorem(10px) pxTorem(20px) pxTorem(10px) pxTorem(50px);
                }
                .formWrap {
                    width: 80%;
                    margin: 0 auto;
                    box-sizing: border-box;
                    padding: pxTorem(10px) pxTorem(20px);

                    @media screen and (max-width: 600px) {
                        width: 100%;
                    }

                    & ::v-deep .el-form-item__label {
                        color: #fff;
                    }
                    & ::v-deep .el-input__inner {
                        color: #fff;
                    }
                    & ::v-deep .el-textarea__inner {
                        background: transparent;
                        color: #fff;
                        font-family: $japaneseFontFamily;
                        &::-webkit-scrollbar {
                            width: 10px;
                        }
                        &::-webkit-scrollbar-track {
                            background-color: #001238;
                            border-radius: 8px;
                        }
                        &::-webkit-scrollbar-thumb {
                            background-color: #407cfd;
                            border-radius: 8px;
                        }
                    }
                    .tip {
                        font-size: pxTorem(10px);
                        color: #afafaf;
                    }
                    .checked {
                        color: #ac7f00;
                    }
                }
            }
            .service {
                .formWrap {
                    width: 100%;
                    padding: pxTorem(10px) pxTorem(50px);
                    font-size: pxTorem(14px);
                    ul {
                        list-style: disc outside none;
                        margin-bottom: pxTorem(20px);
                        li {
                            line-height: 1.5;
                            &.mark {
                                color: rgb(255, 217, 102);
                                font-weight: bold;

                                &::after {
                                    content: "*スマホをご使用の方はPCでご確認ください。";
                                    font-size: pxTorem(11px);
                                }
                            }
                        }
                    }
                    .selbox {
                        text-align: center;
                        label {
                            margin-right: pxTorem(10px);
                        }
                        .btnbox {
                            margin-top: pxTorem(20px);
                            margin-bottom: pxTorem(20px);
                        }
                    }
                }
            }
        }
    }
</style>
